// @flow @jsx h
import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'

/* styles */
import styles from './index.css'

type Props = {
  sitat: string,
  sitatNavn: string,
  float?: string
}

export class Sitat extends Component<Props> {
  render () {
    return <div class={bem(styles.sitat, this.props.float)}>
      <div class={styles.sitat__text}>
        <p>{this.props.sitat}</p>
        <span>{this.props.sitatNavn}</span>
      </div>
    </div>
  }
}
